/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1AssociatedcompanyId200,
  GetApiV1AssociatedcompanyId401,
  GetApiV1AssociatedcompanyId404,
  GetApiV1AssociatedcompanyId500,
  GetApiV1AssociatedcompanyIdPathParams,
  GetApiV1AssociatedcompanyIdQueryResponse,
} from "../../types/associatedCompanyController/GetApiV1AssociatedcompanyId.ts";
import { associatedCompanyDetailViewModelSchema } from "../associatedCompanyDetailViewModelSchema.ts";

export const getApiV1AssociatedcompanyIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1AssociatedcompanyIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1AssociatedcompanyId200Schema = z.lazy(
  () => associatedCompanyDetailViewModelSchema,
) as unknown as ToZod<GetApiV1AssociatedcompanyId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1AssociatedcompanyId401Schema =
  z.any() as unknown as ToZod<GetApiV1AssociatedcompanyId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1AssociatedcompanyId404Schema =
  z.any() as unknown as ToZod<GetApiV1AssociatedcompanyId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1AssociatedcompanyId500Schema =
  z.any() as unknown as ToZod<GetApiV1AssociatedcompanyId500>;

export const getApiV1AssociatedcompanyIdQueryResponseSchema = z.lazy(
  () => getApiV1AssociatedcompanyId200Schema,
) as unknown as ToZod<GetApiV1AssociatedcompanyIdQueryResponse>;
